import { render } from "./cp_school_tese.vue?vue&type=template&id=74ef76ff&scoped=true"
import script from "./cp_school_tese.vue?vue&type=script&lang=js"
export * from "./cp_school_tese.vue?vue&type=script&lang=js"

import "./cp_school_tese.vue?vue&type=style&index=0&id=74ef76ff&scoped=true&lang=css"

import exportComponent from "E:\\WorkCode\\HZY2026\\Code\\HZY.Student\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ef76ff"]])

export default __exports__